import React from "react";

import { Container } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleCheck } from "@fortawesome/free-solid-svg-icons";
import "./CompletedPage.css";

const CompletedPage = () => {
  return (
    <Container className="emp-completed">
      <div className="emp-completed-card" role="status" aria-live="polite">
        <div className="emp-completed-card__hero">
          <div className="emp-completed-card__icon-wrapper">
            <FontAwesomeIcon icon={faCircleCheck} className="emp-completed-card__icon" />
          </div>
          <h1 className="emp-completed-card__title">Form Completed</h1>
        </div>
        <div className="emp-completed-card__body">
          <p className="emp-completed-card__lead">
            Your form has been sent to Hafnia for further management.
          </p>
          <p className="emp-completed-card__hint">
            You can safely close this tab. We will reach out by e-mail if anything else is needed.
          </p>
        </div>
      </div>
    </Container>
  );
};

export default CompletedPage;
